import { SearchResultProduct } from 'store/search/types';
import { LIST_SEARCH_RESULTS_PAGE } from './gtmSearchProductClickEvent';

const gtmSearchProductImpression = (designs: SearchResultProduct[], positions: number[], extraParams: any) => {
  const impressions = designs.map((design, index) => ({
    ...design,
    list: LIST_SEARCH_RESULTS_PAGE,
    position: Number(positions[index]),
  }));

  return {
    event: 'productImpression',
    list: LIST_SEARCH_RESULTS_PAGE,
    ...extraParams,
    ecommerce: {
      currencyCode: 'NOK',
      impressions,
    },
  };
};

export default gtmSearchProductImpression;
